import React, { useState } from 'react';
import { Resizable, ResizeCallback } from 're-resizable';
import styles from './ResizableWrapper.module.scss';

const RESIZE_HANDLE_WIDTH = 24;
const RESIZE_HANDLE_OFFSET = RESIZE_HANDLE_WIDTH / 2;

interface ResizableWrapperProps {
  children: React.ReactNode;
  className?: string;
  minWidth?: number;
  maxWidth?: number | string;
  defaultWidth?: number;
  onResizeStop?: ResizeCallback;
}

export const ResizableWrapper: React.FC<ResizableWrapperProps> = ({
  children,
  className,
  minWidth = 250,
  maxWidth = 600,
  defaultWidth = 304,
  onResizeStop,
}) => {
  const [isHandleHovered, setIsHandleHovered] = useState(false);

  return (
    <Resizable
      className={`${styles.resizableWrapper} ${
        isHandleHovered ? styles.resizableWrapperHovered : ''
      } ${className || ''}`}
      minWidth={minWidth}
      maxWidth={maxWidth}
      defaultSize={{ width: defaultWidth, height: 'auto' }}
      enable={{
        top: false,
        right: true,
        bottom: false,
        left: false,
        topRight: false,
        bottomRight: false,
        bottomLeft: false,
        topLeft: false,
      }}
      handleStyles={{
        right: {
          right: `-${RESIZE_HANDLE_OFFSET}px`,
          width: `${RESIZE_HANDLE_WIDTH}px`,
          zIndex: 5,
        },
      }}
      handleComponent={{
        right: (
          <div
            className={styles.resizeHandle}
            data-testid="resize-handle"
            onMouseEnter={() => setIsHandleHovered(true)}
            onMouseLeave={() => setIsHandleHovered(false)}
          />
        ),
      }}
      onResizeStop={onResizeStop}
    >
      {children}
    </Resizable>
  );
};
